import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from '@bayon/i18n';
import { Tooltip, Typography } from '@bayon/commons';

import { useFields } from '../../../../../../hooks';

import { useStyles } from './TreeSubItem.styles';

const UNSUPPORTED_TYPES = ['NAUT'];

export const TreeSubItem = ({ id, nome, descricao, type }) => {
  const classes = useStyles();
  const { addField } = useFields();
  const { t } = useTranslation('editorWordAddin');

  const handleAddField = () => addField({ id, nome, descricao, type });

  const isUnimplementedType = UNSUPPORTED_TYPES.includes(type);

  const label = isUnimplementedType ? t('FIELD_NOT_SUPPORTED') : descricao;

  return (
    <Tooltip aria-label={label} label={label} placement="top" textAlign="left">
      <button
        size={12}
        disabled={isUnimplementedType}
        data-testid={`tree-sub-item-${id}`}
        className={classes.root}
        onClick={handleAddField}
      >
        <Typography noWrap weight="regular">
          {nome}
        </Typography>
      </button>
    </Tooltip>
  );
};

TreeSubItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  nome: PropTypes.string.isRequired,
  descricao: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
